import { useLayoutEffect, useState } from 'react';

const useResize = () => {
  const [size, setSize] = useState({ width: 0, height: 0 });
  const isMobile = size.width < 768;
  const isTablet = size.width >= 768 && size.width < 1024;
  const isDesktop = size.width >= 1024;

  useLayoutEffect(() => {
    const getSize = () => setSize({ width: window.innerWidth, height: window.innerHeight });
    getSize();
    window.addEventListener('resize', getSize);
    return () => window.removeEventListener('resize', getSize);
  }, []);

  return { ...size, isMobile: isMobile, isTablet: isTablet, isDesktop: isDesktop };
};

export default useResize;
